export default "__VITE_ASSET__95a84e37__"